import React from 'react';
import { Modal, Table } from 'antd';

function MemberListModal({ list, visible, onClose }) {
  return (
    <Modal
      className="projecthome-sort-modal group-member-list-modal"
      onCancel={onClose}
      visible={visible}
      footer={null}
    >
      <h3 className="title">Member List</h3>
      <Table
        columns={[
          {
            dataIndex: 'email',
            title: 'Email',
            align: 'left',
            width: '18.75rem',
          },
          {
            dataIndex: 'name',
            title: 'Name',
            align: 'left',
            width: '12.5rem',
            render: (_, record) => record?.fullName || record?.name,
          },
          {
            dataIndex: 'role_name',
            title: 'Role',
            align: 'left',
            width: '12.5rem',
          },
        ]}
        dataSource={list}
        pagination={false}
        scroll={{
          y: '18.75rem',
        }}
      />
    </Modal>
  );
}

export default MemberListModal;
